export const noopDisposable = async () => {
};
export const composeDisposables = (...disposables) => async () => {
    await Promise.all(disposables.map((dispose) => dispose()));
};

//# sourceMappingURL=Disposable.js.map
